import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#152e25] text-[#f4f1e8] relative pt-16 pb-8 border-t-8 border-[#d4af37]" data-id="element-5">
      <div className="max-w-6xl mx-auto px-4" data-id="element-6">
        {/* Ornamental Divider */}
        <div className="flex items-center justify-center mb-12 opacity-50" data-id="element-7">
          <div className="h-px bg-[#d4af37] flex-1" data-id="element-8"></div>
          <div className="px-4 font-script text-2xl text-[#d4af37]" data-id="element-9">KMI</div>
          <div className="h-px bg-[#d4af37] flex-1" data-id="element-10"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left" data-id="element-11">
          <div data-id="element-12">
            <h3 className="font-display text-4xl mb-6 text-[#d4af37]" data-id="element-13">
              Kontakt
            </h3>
            <ul className="space-y-4 font-serif text-lg" data-id="element-14">
              <li className="flex items-center justify-center md:justify-start gap-3" data-id="element-15">
                <Phone className="w-5 h-5 text-[#d4af37]" data-id="element-16" />
                <span data-id="element-17">+48 123 456 789</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3" data-id="element-18">
                <Mail className="w-5 h-5 text-[#d4af37]" data-id="element-19" />
                <span data-id="element-20">kontakt@kmipolska.pl</span>
              </li>
            </ul>
          </div>

          <div className="text-center" data-id="element-21">
            <h3 className="font-display text-5xl mb-4 tracking-widest" data-id="element-22">
              KMI POLSKA
            </h3>
            <p className="font-serif italic text-[#d4af37]" data-id="element-23">
              "Jakość, która przetrwa pokolenia."
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end" data-id="element-24">
            <h3 className="font-display text-4xl mb-6 text-[#d4af37]" data-id="element-25">
              Obserwuj Nas
            </h3>
            <div className="flex gap-6" data-id="element-26">
              <a href="#" className="hover:text-[#d4af37] transition-colors duration-300" data-id="element-27">
                <Facebook className="w-8 h-8" data-id="element-28" />
              </a>
              <a href="#" className="hover:text-[#d4af37] transition-colors duration-300" data-id="element-29">
                <Instagram className="w-8 h-8" data-id="element-30" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1a3a2e] text-center font-serif text-sm opacity-60" data-id="element-31">
          <p data-id="element-32">
            &copy; 2024 KMI Polska. Wszelkie prawa zastrzeżone. Projekt
            inspirowany Little Italy.
          </p>
        </div>
      </div>
    </footer>;
}